module.exports = __webpack_public_path__ + "static/banner-172510c597881ceb442516186b228dbc.png";